import React from "react";
import PropTypes from "prop-types";
import { Trans } from "@lingui/macro";
import styled from "styled-components";
import {
  DisplaySmall,
  borderRadius,
  spacing,
  layer,
  opacity,
} from "@conserveit/blocks";

const Overlay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: ${({ posRel }) => (posRel ? "relative" : "absolute")};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: ${spacing.extraLoose};
  font-size: 19px;
  background: ${({ omitBackground }) =>
    omitBackground ? "none" : `rgba(255, 255, 255, ${opacity.tint})`};
  z-index: ${layer.fixedContent};
  border-radius: 0 0 ${borderRadius.large} ${borderRadius.large};
`;

const NoResultsOverlay = ({
  noResultsMessage,
  selectedSitesMessage,
  omitBackground,
  posRel,
  noActionsMessage,
}) => (
  <Overlay omitBackground={omitBackground} posRel={posRel}>
    <DisplaySmall>
      {noResultsMessage && (
        <Trans id="no_results_overlay.no_results_message">
          0 results match the current filter(s).
        </Trans>
      )}
      {selectedSitesMessage && (
        <Trans id="no_results_overlay.found_for_selected_sites">
          0 results found for your selected sites
        </Trans>
      )}
      {noActionsMessage && (
        <Trans id="no_results_overlay.found_for_selected_insight">
          0 Active actions found for selected site
        </Trans>
      )}
    </DisplaySmall>
  </Overlay>
);

NoResultsOverlay.propTypes = {
  noActionsMessage: PropTypes.bool,
  noResultsMessage: PropTypes.bool,
  selectedSitesMessage: PropTypes.bool,
  omitBackground: PropTypes.bool,
  posRel: PropTypes.bool,
};

NoResultsOverlay.defaultProps = {
  noActionsMessage: false,
  noResultsMessage: false,
  selectedSitesMessage: false,
  omitBackground: false,
  posRel: false,
};

export default NoResultsOverlay;
